import ApiService from './api'

const base = 'modelos-pecas/rag/pesquisas/providers'

const JurisprudenceProviders = {
  list: (signal) => ApiService.request(`${base}/configuracoes`, { signal }),
  update: (providerId, configuration, signal) => ApiService.request(
    `${base}/${encodeURIComponent(providerId)}/configuracao`, {
      method: 'PUT', body: JSON.stringify(configuration), signal,
    }),
}

export default JurisprudenceProviders
